import backIcon from '/asset/back-arrow.svg';
import Content from './Content';

interface BackNavBarProps {
  label: string;
  onClick: () => void;
}

export default function BackNavBar({ label, onClick }: BackNavBarProps) {
  return (
    <div
      className="shadow-inner shadow-sm shadow-gray-300 w-full
      h-[50px] py-[12px] px-[10px] border-b-[1px] border-primary-200
      bg-secondary-50"
    >
      <Content>
        <div
          className="cursor-pointer text-primary-800
          hover:text-secondary-700 text-[12px]
          content-center flex gap-[3px]"
          onClick={onClick}
        >
          <img
            src={backIcon}
            className="h-[20px] inline-block mr-[5px] object-contain"
          />
          <div className="pt-[1px]">{label}</div>
        </div>
      </Content>
    </div>
  );
}
